import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BcBreadcrumbModule } from '@bancolombia/design-system-web/bc-breadcrumb';
import { BcTableModule } from '@bancolombia/design-system-web/bc-table';
import { BcPaginatorModule } from '@bancolombia/design-system-web/bc-paginator';
import { BcInputModule } from '@bancolombia/design-system-web/bc-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BcIconButtonModule } from '@bancolombia/design-system-web/bc-icon-button';
import { BcLoaderModule } from '@bancolombia/design-system-web/bc-loader';
import { BcModalModule } from '@bancolombia/design-system-web/bc-modal';
import { BcButtonModule } from '@bancolombia/design-system-web/bc-button';
import { BcCircleLoadingModule } from '@bancolombia/design-system-web/bc-circle-loading';
import { BcIconModule } from '@bancolombia/design-system-web/bc-icon';
import { BcFloatMenuModule } from '@bancolombia/design-system-web/bc-float-menu';
import { BcTagModule } from '@bancolombia/design-system-web/bc-tag';
import { BcInputSelectModule } from '@bancolombia/design-system-web/bc-input-select';
import { BcAccordionModule } from '@bancolombia/design-system-web/bc-accordion';
import { BcRadioModule } from '@bancolombia/design-system-web/bc-radio';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BcTabsModule } from '@bancolombia/design-system-web/bc-tabs-group';
import { BcInputFileModule } from '@bancolombia/design-system-web/bc-input-file';


import { CoreRoutingModule } from './core-routing.module';
import { MainComponent } from '../main/main.component';
import { CoreComponent } from './core.component';
import { FacturaHomeComponent } from '../pages/factura/factura-home/factura-home.component';
import { BuscadorFacturasComponent } from '../shared/components/buscador-facturas/buscador-facturas.component';
import { ReporteFacturaComponent } from '../shared/components/reporte-factura/reporte-factura.component';
import { ReporteVfiscalComponent } from '../shared/components/reporte-vfiscal/reporte-vfiscal.component';
import { FacturasTableComponent } from '../shared/components/facturas-table/facturas-table.component';
import { ModalComponent } from '../shared/modal/modal.component';
import { HeaderComponent } from '../shared/header/header.component';
import { FooterComponent } from '../shared/footer/footer.component';
import { TitleAndBreadcrumbComponent } from '../shared/title-and-breadcrumb/title-and-breadcrumb.component';
import { FacturaDetalleComponent } from '../pages/factura/factura-detalle/factura-detalle.component';
import { FacturaCoreModule } from '../pages/factura/factura-core/factura-core.module';
import { BadRequestComponent } from '../shared/bad-request/bad-request.component';
import { HeaderInterceptor } from 'src/app/infrastructure/interceptors/header.interceptor';
import { BtnCambioEstadoComponent } from '../shared/components/btn-cambio-estado/btn-cambio-estado.component';
import { SubirArchivoAdjuntoComponent } from '../shared/components/subir-archivo-adjunto/subir-archivo-adjunto.component';
import { ListarArchivosAdjuntosComponent } from '../shared/components/listar-archivos-adjuntos/listar-archivos-adjuntos.component';


@NgModule({
  declarations: [
    BuscadorFacturasComponent,
    BadRequestComponent,
    CoreComponent,
    FacturaHomeComponent,
    FacturasTableComponent,
    FooterComponent,
    FacturaDetalleComponent,
    HeaderComponent,
    ModalComponent,
    MainComponent,
    ReporteFacturaComponent,
    TitleAndBreadcrumbComponent,
    BtnCambioEstadoComponent,
    SubirArchivoAdjuntoComponent,
    ListarArchivosAdjuntosComponent,
    ReporteVfiscalComponent,
  ],
  imports: [
    CommonModule,
    CoreRoutingModule,
    BcBreadcrumbModule,
    BcTableModule,
    BcPaginatorModule,
    BcInputModule,
    FormsModule,
    ReactiveFormsModule,
    BcIconButtonModule,
    BcLoaderModule,
    BcModalModule,
    BcButtonModule,
    BcCircleLoadingModule,
    BcIconModule.forRoot({ path: '' }),
    HttpClientModule,
    FacturaCoreModule,
    HttpClientModule,
    BcFloatMenuModule,
    BcTagModule,
    BcInputSelectModule,
    BcAccordionModule,
    BcRadioModule,
    BcTabsModule,
    BcInputFileModule
  ],
  exports:[
    FooterComponent,
  ],
  providers:[
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true
    }
  ]
})
export class CoreModule { }
